import { useRef, useEffect } from 'react';

const Fadeup = ({
	children,
	className = '',
	delay = 0,
	triggerOffset = '0px',
}) => {
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('fade-up-visible');
						observer.unobserve(entry.target);
					}
				});
			},
			{
				threshold: 0.1,
				rootMargin: triggerOffset,
			}
		);

		if (sectionRef.current) {
			observer.observe(sectionRef.current);
		}

		// Clean up just in case
		return () => {
			if (sectionRef.current) observer.unobserve(sectionRef.current);
		};
	}, [triggerOffset]);

	return (
		<div
			ref={sectionRef}
			className={`fade-up ${className}`}
			style={{ transitionDelay: `${delay}s` }}
		>
			{children}
		</div>
	);
};

export default Fadeup;
